<div
  class="grid-stack-item-content"
  [ngClass]="{
    isDraggable: draggable,
    'tripist-theme': primaryIntegrationType === 'tripist',
    'explorist-theme': primaryIntegrationType === 'explorist',
    'aura-theme': primaryIntegrationType === 'aura'
  }"
>
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">{{ widgetTitle }}</div>
    <div class="options">
      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="white"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <div class="row" *ngIf="!noIntegrationFound">
      <div class="metrics-column">
        <div class="metric-item">
          <div class="metric-icon">
            <mat-icon>smartphone</mat-icon>
          </div>
          <div class="metric-content">
            <div class="metric-value">{{ totalDevices ? totalDevices : "0" }}</div>
            <div class="metric-label">Total Devices</div>
          </div>
        </div>
        <div class="metric-item">
          <div class="metric-icon">
            <mat-icon>people</mat-icon>
          </div>
          <div class="metric-content">
            <div class="metric-value">{{ totalUsers ? totalUsers : "0" }}</div>
            <div class="metric-label">Total Users</div>
          </div>
        </div>
      </div>
      <div class="graph">
        <div echarts [options]="devicesUsersChartOptions" class="bar-chart"></div>
      </div>
    </div>
    <div class="no-integration-message" *ngIf="noIntegrationFound">
      <div class="message-container">
        <svg-icon 
          src="assets/svg/integrations.svg" 
          [svgStyle]="{
            'width.px': '50',
            'height.px': '50'
          }"
        ></svg-icon>
        <div class="message-text">
          <h4>No Enabled Assistant Integrations Found</h4>
          <p>To view assistant devices and users data, set up at least one enabled assistant integration ({{ enabledAssistantLabel }}).</p>
        </div>
      </div>
    </div>
  </div>
</div> 